import { MESSAGE_TOO_LONG_COPY } from '../components/chat/messageLimit';

/**
 * TRACI-472 follow-up: the backend refused this exact request (400, 413 or 422).
 * Sending it again cannot succeed, so the chat must not treat it as a lost
 * connection and auto-retry it.
 */
export class RequestRejectedError extends Error {
  readonly status: number;
  readonly userMessage: string;
  constructor(status: number, userMessage: string) {
    super(`Request rejected: ${status}`);
    this.name = 'RequestRejectedError';
    this.status = status;
    this.userMessage = userMessage;
  }
}

/** True for the statuses where the same request will never be accepted. */
export function isRejectedStatus(status: number): boolean {
  return status === 400 || status === 413 || status === 422;
}

/** Plain-English copy for a rejected send; `body` is the parsed JSON error, if any. */
export function rejectedCopy(status: number, body: unknown): string {
  if (status === 413) return MESSAGE_TOO_LONG_COPY;
  const detail = (body as { detail?: unknown } | null)?.detail;
  // Only the typed message (the `prompt` field) is the customer's to shorten; a too-long
  // pageData or other field is not something they can fix by editing what they typed.
  const promptTooLong = Array.isArray(detail) && detail.some((d) => {
    const item = d as { type?: string; loc?: unknown } | null;
    return item?.type === 'string_too_long' && Array.isArray(item.loc) && item.loc.includes('prompt');
  });
  if (promptTooLong) {
    return MESSAGE_TOO_LONG_COPY;
  }
  return "We couldn't send that message. Please check it and try again.";
}
